import { render, staticRenderFns } from "./BrigadeMapPerformedTasks.vue?vue&type=template&id=5ed5e650&"
import script from "./BrigadeMapPerformedTasks.vue?vue&type=script&lang=js&"
export * from "./BrigadeMapPerformedTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBanner,QIcon} from 'quasar'
component.options.components = Object.assign({QBanner,QIcon}, component.options.components || {})
